<template>
  <div>
    <div class='map'>
      <div class='setting' v-if='!$attrs.view'>
        <i class='el-icon-s-tools' @click='editLocate'></i>
      </div>

      <div class='mapClass' ref='mapContainer'></div>
      <MapDetail
        v-if='!$attrs.view'
        ref='MapDetail'
        v-show='isShow'
        @closeFn='closeFn'
        @searchFn='searchFn'
        @locationFn='locationFn'
        :initObj='initObj'
        :isBoolShowWin='isBoolShowWin'
        :isShow='isShow'
        :poiArr='poiArr'
        :mapObj='mapObj'
      />
    </div>
  </div>
</template>

<script>
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import MapboxLanguage from '@mapbox/mapbox-gl-language'
import { getLanguage } from '@/lang'
import { marker_location } from '../../../../home/config/mapIcon'
import MapDetail from './MapDetail.vue'
import { wgs84togcj02 } from '@/utils/postion'

export default {
  props: ['mapObj', 'treeObj', 'address'],
  components: {
    MapDetail
  },
  watch: {
    mapObj: {
      handler (newVal) {
        this.newMapObj = { ...newVal }
      }
    }
  },
  data () {
    return {
      isShow: false,
      newMapObj: {},
      newMap: null,
      poiArr: [],
      marker: null,
      windowsArr: [],
      map: '',
      initObj: {},
      isBoolShowWin: false,
      modified: false
    }
  },
  beforeDestroy () {
    if (this.newMap) {
      this.newMap.remove()
      this.newMap = null
    }
  },
  methods: {
    getMapboxLanguage () {
      const lang = getLanguage().split('_')[0]
      const mapping = {
        'zh': 'zh-Hans',
        'en': 'en',
        'es': 'es',
        'ja': 'ja'
      }
      return mapping[lang] || 'en'
    },
    mapInit (arrayPoint = []) {
      const that = this
      const center = {
        longitude: this.mapObj.longitude,
        latitude: this.mapObj.latitude
      }
      if (!arrayPoint.length) arrayPoint = wgs84togcj02(center.longitude, center.latitude)

      if (that.newMap) {
        that.newMap.remove()
        that.newMap = null
      }

      const token = process.env.VUE_APP_MAPBOX_TOKEN
      if (!token) {
        console.error('Mapbox token is not configured')
        return
      }

      mapboxgl.accessToken = token
      mapboxgl.telemetryEnabled = false

      // 使用 ref 而非 id，避免页面上多个 #map 元素冲突（如首页 planeMap 缓存时仍存在）
      const mapContainer = that.$refs.mapContainer
      if (!mapContainer) {
        console.error('Map container element not found')
        return
      }

      that.newMap = new mapboxgl.Map({
        container: mapContainer,
        style: 'mapbox://styles/mapbox/streets-v12',
        center: arrayPoint,
        zoom: 16,
        attributionControl: false
      })

      that.newMap.addControl(new mapboxgl.NavigationControl())

      const language = that.getMapboxLanguage()
      const languagePlugin = new MapboxLanguage({
        defaultLanguage: language
      })
      that.newMap.addControl(languagePlugin)

      that.newMap.on('load', () => {
        that.addMarker(arrayPoint)
      })

      that.newMap.on('click', e => {
        if (this.$attrs.view) {
          return
        }
        if (that.marker) {
          that.marker.remove()
          that.marker = null
        }
        const lng = e.lngLat.lng
        const lat = e.lngLat.lat
        that.changeAddressFn([lng, lat])
        that.$nextTick(() => {
          that.$refs.MapDetail && that.$refs.MapDetail.clearValidate()
        })
        that.addMarker([lng, lat])
      })
    },
    addMarker (position) {
      const el = document.createElement('div')
      el.innerHTML = marker_location
      el.style.width = '30px'
      el.style.height = '30px'
      el.style.display = 'flex'
      el.style.alignItems = 'center'
      el.style.justifyContent = 'center'

      this.marker = new mapboxgl.Marker(el)
        .setLngLat(position)
        .addTo(this.newMap)
    },
    async changeAddressFn (initPoint) {
      let address = ''

      try {
        const res = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${initPoint[0]},${initPoint[1]}.json?access_token=${process.env.VUE_APP_MAPBOX_TOKEN}&limit=1`)
        const data = await res.json()
        if (data.features && data.features.length) {
          address = data.features[0].place_name
        }
      } catch (err) {
        console.error('Mapbox reverse geocoding error:', err)
      }
      this.initObj = {
        longitude: String(initPoint[0]),
        latitude: String(initPoint[1]),
        address: address
      }
    },
    lngLatConvert (initPoint) {
      return Promise.resolve('')
    },
    closeFn () {
      this.isShow = !this.isShow
    },
    async searchFn (name) {
      this.windowsArr = []
      this.marker = null
      this.isBoolShowWin = true
      this.isShow = true

      try {
        const response = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(name)}.json?access_token=${process.env.VUE_APP_MAPBOX_TOKEN}&limit=10`)
        const data = await response.json()

        if (data.features && data.features.length) {
          const poiArr = data.features.map(r => ({
            id: r.id,
            name: r.text,
            address: r.place_name,
            location: {
              lng: r.center[0],
              lat: r.center[1],
              getLng: () => r.center[0],
              getLat: () => r.center[1]
            },
            photos: r.properties && r.properties.photos ? r.properties.photos : []
          }))
          this.keywordSearch_CallBack({ poiList: { pois: poiArr } })
        } else {
          this.poiArr = []
        }
      } catch (e) {
        console.error('Mapbox geocoding error:', e)
        this.poiArr = []
      }
    },
    locationFn (obj) {
      const {
        id,
        address,
        longitude,
        latitude,
        addressCheck
      } = obj
      const locationPoint = [Number(longitude), Number(latitude)]

      this.mapInit(locationPoint)
      this.$emit('locateCallback', obj)
    },
    keywordSearch_CallBack (data) {
      const poiArr = data.poiList.pois
      const resultCount = poiArr.length
      this.poiArr = poiArr
      const bounds = new mapboxgl.LngLatBounds()
      for (let i = 0; i < resultCount; i++) {
        this.addSearchMarker(i, poiArr[i])
        this.poiArr[i].url = this.poiArr[i].photos ? (this.poiArr[i].photos[0] ? this.poiArr[i].photos[0].url : '') : ''
        bounds.extend([poiArr[i].location.getLng(), poiArr[i].location.getLat()])
      }
      this.newMap.fitBounds(bounds, {
        padding: 50,
        maxZoom: 16
      })
    },
    addSearchMarker (i, d) {
      const lngX = d.location.getLng()
      const latY = d.location.getLat()
      const el = document.createElement('div')
      el.innerHTML = marker_location
      el.style.width = '30px'
      el.style.height = '30px'
      el.style.display = 'flex'
      el.style.alignItems = 'center'
      el.style.justifyContent = 'center'

      const marker = new mapboxgl.Marker(el)
        .setLngLat([lngX, latY])
        .addTo(this.newMap)

      this.windowsArr.push(marker)
    },
    TipContents (name, address) {
      if (name === '' || name === 'undefined' || name == null || name === ' undefined' || typeof name === 'undefined') {
        type = this.$t('public.btn_noData')
      }
      if (address === '' || address === 'undefined' || address == null || address === ' undefined' || typeof address === 'undefined') {
        address = this.$t('public.btn_noData')
      }
      return this.$t('text.Address') + `：${address}`
    },
    demo (e) {
      if (e.target.id === 'me') {
        e.stopPropagation()
        this.saveAddress()
      }
    },
    saveAddress () {
      alert('' + this.$t('messageTitle.AddressAlreadySave'))
    },
    editLocate () {
      this.isShow = true
    }
  },
  mounted () {
    this.mapInit()
    if (this.mapObj.address) {
      this.isShow = true
    }
  }
}
</script>

<style lang='scss' scoped>
.map {
  height: calc(100% - 50px);
  width: 100%;
  position: relative;
}

.mapClass {
  height: 700px;
  width: 100%;
}

.setting {
  position: absolute;
  top: 3px;
  left: 3px;
  z-index: 99;

  width: 30px;
  height: 30px;

  i {
    font-size: 35px;
  }
}
</style>
